import PropTypes from 'prop-types';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Card, Grid, Avatar, Typography, CardContent, CardActions, Button } from '@mui/material';
// utils
import { fDate } from '../../utils2/formatTime';
import SvgColor from '../../components2/svg-color/SvgColor';
import { useState } from 'react';
import CreatePopup from '../../components/createPopup/CreatePopup';
import Login from '../../pages/Login3';
import { useCartContext } from '../../context/cart/cart_context';
import { Link, useNavigate } from 'react-router-dom';
import BookDemoPopup from '../bookDemo/BookDemoPopup';
import { useSelector } from 'react-redux';
import Login3 from '../../pages/Login3';
//

// ----------------------------------------------------------------------

const StyledCardMedia = styled('div')({
  position: 'relative',
  paddingTop: 'calc(100% * 3 / 4)',
});

const StyledTitle = styled(Link)({
  height: 44,
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: 32,
  height: 32,
  position: 'absolute',
  left: theme.spacing(3),
  bottom: theme.spacing(-2),
}));

const StyledInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled,
}));

const StyledCover = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

ClassCard.propTypes = {
  post: PropTypes.object.isRequired,
  index: PropTypes.number,
};

export default function ClassCard({ course, index }) {
    const {addToCart} = useCartContext()
    const { isAuthenticated } = useSelector((state) => state.auth);
    const navigate = useNavigate()
  const {
    id,
    name,
    start_date,
    end_date,
    test_type_id,
    creator_name,
    price,
    level,
    mode_of_delivery,
    seat_availability,
    day_left,
    start_time,
    end_time, 
    branch
  } = course;

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenBookDemoPopup, setIsOpenBookDemoPopup] = useState(false);

  const isSeatAvailable = seat_availability > 0;

  const handleOpenSignInPopup = () => {
    setIsOpen(true);
  };

  const handleCloseSignInPopup = () => {
    setIsOpen(false);
  };

  const handleOpenBookDemoPopup = () => {
    setIsOpenBookDemoPopup(true);
    setIsOpen(false)
  };

  // Function to handle the Book Demo popup close
  const handleCloseBookDemoPopup = () => {
    setIsOpenBookDemoPopup(false);
  };

  const handleOpenCart = () => {
    addToCart(id, name, creator_name, price, test_type_id)
    navigate('/allcourses2/cart')
  }

  const handleBookDemoClick = () => {
    if (isAuthenticated) {
      handleOpenBookDemoPopup();
    } else {
      handleOpenSignInPopup();
    }
  };

  const handleEnrollClick = () => {
    if (isAuthenticated) {
      handleOpenCart();
    } else {
      handleOpenSignInPopup();
    }
  }


  return (
    <>
    <Grid item xs={6} md={4}>
      <Card sx={{ position: 'relative' }}>
        <CardContent
          sx={{
            pt: 2, // Increase the top spacing
            pb: 2, // Decrease the bottom spacing
           
          }}
        >
          <Typography gutterBottom variant="caption" sx={{ color: 'text.disabled', display: 'block' }}>
            {fDate(start_date)}
          </Typography>

          <StyledTitle
            color="inherit"
            variant="h4"
            underline="hover"
           
          >
            Class Times : {start_time} - {end_time}
           
        </StyledTitle> 
          <Typography variant="h5">IELTS</Typography>

          <Typography variant='h6'>Mode of Delivery: {mode_of_delivery}</Typography>
          <Typography paragraph>Monday - Saturday</Typography>
            <Typography paragraph>Level: {level}</Typography>
            <Typography variant="body2" color="error" paragraph>
              Available: {seat_availability} spaces left
            </Typography>
            <Typography paragraph>Price: ${price}</Typography>
            {!isSeatAvailable && (
                <>
                  {/*<SvgColor
                    icon="lockFill"
                    color="error"
                    sx={{
                      width: 16,
                      height: 16,
                      mr: 0.5,
                      verticalAlign: 'middle',
                    }}
                /> */}
                  <Typography variant="h6" color="error" paragraph>
                    No seats available for this class
                  </Typography>
                </>
              )}
            <Box>
            
        <Button variant="contained" color="primary" onClick={handleBookDemoClick} disabled={!isSeatAvailable}>
          Book Demo
        </Button>
        <Button variant="contained" color="primary"  onClick={handleEnrollClick} disabled={!isSeatAvailable}>
          Enroll
        </Button>
        <Button>
        </Button>
        </Box>
        </CardContent>
      </Card>
      <CreatePopup 
        open={isOpen}
        onClose={handleCloseSignInPopup}
        component={<Login3 />}
      /> 
        <BookDemoPopup
            open={isOpenBookDemoPopup} 
            onClose={handleCloseBookDemoPopup} 
            courseId={id}
            />
     
    </Grid>
    </>
  );
}